import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AuctionPageDashboard from "../AuctionPageDashboard";
import BiddingConsumer from "./BiddingConsumer";
import BiddingGenerator from "./BiddingGenerator";
import { tenderSpecefic } from "../../../../../Redux/Slices/auctionSlice";
import { useLocation } from "react-router-dom";

const LiveReverseAuction = () => {
  const location = useLocation();
  let tenderId = location?.search?.split("=")[1];
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole
  ).toLowerCase();
  const dispatch = useDispatch();

  useEffect(() => {
    getAuction();
  }, []);

  const getAuction = () => {
    dispatch(tenderSpecefic(tenderId));
  };

  return (
    <>
      {role === "consumer" ? (
        <BiddingConsumer type={"AUCTION"} />
      ) : role === "generator" ? (
        <BiddingGenerator type={"AUCTION"} />
      ) : (
        <AuctionPageDashboard />
      )}
    </>
  );
};

export default LiveReverseAuction;
